/**
 * <infinite-scroll> — auto-loads more products and appends them to the list.
 */
(function () {
  if (window.customElements && window.customElements.get('infinite-scroll')) return;

  var AUTO_LOAD_LIMIT = 3;
  var LOG = function () {
    try {
      var args = ['[infinite-scroll]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    } catch (e) {}
  };
  var WARN = function () {
    try {
      var args = ['[infinite-scroll]'].concat(Array.prototype.slice.call(arguments));
      console.warn.apply(console, args);
    } catch (e) {}
  };

  function getNextUrl(pagWrap) {
    if (!pagWrap) return '';
    var dataUrl = pagWrap.getAttribute('data-next-url');
    if (dataUrl) return dataUrl;
    var nextAnchor = pagWrap.querySelector('a[rel="next"]');
    if (nextAnchor && nextAnchor.getAttribute('href')) return nextAnchor.getAttribute('href');
    var horizonNext = pagWrap.querySelector('.pagination__next a, .pagination a[aria-label*="Next" i]');
    if (horizonNext && horizonNext.getAttribute('href')) return horizonNext.getAttribute('href');
    return '';
  }

  function absoluteUrl(href) {
    try { return new URL(href, window.location.origin).toString(); } catch (e) { return href; }
  }

  /**
   * Force-show appended cards by removing the theme's reveal-on-scroll behavior
   * (the theme's IntersectionObserver only watches cards present at page load).
   * We also unhide common hidden states and force opacity for safety.
   */
  function unhideAppendedCards(rootEl) {
    if (!rootEl) return;
    var cards = rootEl.querySelectorAll('product-card[reveal-on-scroll], [reveal-on-scroll]');
    cards.forEach(function (el) {
      el.removeAttribute('reveal-on-scroll');
      el.classList.add('is-revealed', 'is-visible');
      try {
        el.style.opacity = '1';
        el.style.visibility = 'visible';
        el.style.transform = 'none';
      } catch (e) {}
    });
  }

  function setStatusLoading(statusEl) {
    if (!statusEl) return;
    statusEl.classList.remove('infinite-scroll__status--error');
    statusEl.innerHTML =
      '<span class="infinite-scroll__loader" aria-hidden="true"></span>' +
      '<span class="infinite-scroll__loader-text">Loading<span class="infinite-scroll__dots" aria-hidden="true"></span></span>';
  }
  function clearStatus(statusEl) {
    if (!statusEl) return;
    statusEl.classList.remove('infinite-scroll__status--error');
    statusEl.innerHTML = '';
  }
  function setStatusError(statusEl, message) {
    if (!statusEl) return;
    statusEl.classList.add('infinite-scroll__status--error');
    statusEl.textContent = message || 'Couldn\u2019t load more. Tap \u201CLoad more\u201D to try again.';
  }

  function findListInDoc(doc, sectionId) {
    var node = null;
    if (sectionId) node = doc.getElementById('product-list-' + sectionId);
    if (!node) node = doc.querySelector('[data-infinite-list]');
    if (!node) node = doc.querySelector('product-list');
    if (!node) node = doc.querySelector('.product-list');
    return node;
  }
  function findPaginationInDoc(doc) {
    return doc.querySelector('[data-infinite-pagination]') || doc.querySelector('.pagination');
  }

  var InfiniteScrollEl = (function () {
    function InfiniteScrollEl() {
      var self = Reflect.construct(HTMLElement, [], InfiniteScrollEl);
      self._loaded = 0;
      self._busy = false;
      self._done = false;
      self._observer = null;
      return self;
    }
    InfiniteScrollEl.prototype = Object.create(HTMLElement.prototype);
    InfiniteScrollEl.prototype.constructor = InfiniteScrollEl;
    Object.setPrototypeOf(InfiniteScrollEl.prototype, HTMLElement.prototype);
    Object.setPrototypeOf(InfiniteScrollEl, HTMLElement);

    InfiniteScrollEl.prototype.connectedCallback = function () {
      var self = this;
      LOG('connected');

      self.listEl = self.querySelector('[data-infinite-list]');
      self.pagWrap = self.querySelector('[data-infinite-pagination]');
      self.sentinel = self.querySelector('[data-infinite-sentinel]');
      self.statusEl = self.querySelector('[data-infinite-status]');
      self.loadMoreBtn = self.querySelector('[data-infinite-load-more]');

      if (!self.listEl) { WARN('no [data-infinite-list], aborting.'); return; }
      if (!self.pagWrap) { WARN('no [data-infinite-pagination], aborting.'); return; }

      var currentPage = self.pagWrap.getAttribute('data-current-page') || '?';
      var totalPages = self.pagWrap.getAttribute('data-total-pages') || '?';
      var nextUrl = getNextUrl(self.pagWrap);
      LOG('current page', currentPage, 'of', totalPages, '| next URL =', nextUrl || '(none)');

      if (!nextUrl) {
        if (self.loadMoreBtn) self.loadMoreBtn.setAttribute('hidden', '');
        return;
      }

      var listId = self.listEl.id || '';
      self.sectionId = listId.replace(/^product-list-/, '');
      LOG('section id =', self.sectionId);

      if (self.loadMoreBtn) {
        self.loadMoreBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self.loadNext(true);
        });
      }

      if ('IntersectionObserver' in window && self.sentinel) {
        try {
          self._observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting && !self._busy && !self._done) {
                if (self._loaded < AUTO_LOAD_LIMIT) {
                  LOG('sentinel intersected, auto-loading (count=' + self._loaded + ')');
                  self.loadNext(false);
                } else {
                  LOG('auto-load limit reached, showing Load more button.');
                  self.showLoadMore();
                  self.disconnectObserver();
                }
              }
            });
          }, { rootMargin: '800px 0px', threshold: 0 });
          self._observer.observe(self.sentinel);
        } catch (err) {
          WARN('observer failed:', err);
          self.showLoadMore();
        }
      } else {
        self.showLoadMore();
      }
    };

    InfiniteScrollEl.prototype.disconnectedCallback = function () { this.disconnectObserver(); };
    InfiniteScrollEl.prototype.disconnectObserver = function () {
      if (this._observer) { try { this._observer.disconnect(); } catch (e) {} this._observer = null; }
    };
    InfiniteScrollEl.prototype.showLoadMore = function () { if (this.loadMoreBtn) this.loadMoreBtn.removeAttribute('hidden'); };
    InfiniteScrollEl.prototype.hideLoadMore = function () { if (this.loadMoreBtn) this.loadMoreBtn.setAttribute('hidden', ''); };

    InfiniteScrollEl.prototype.loadNext = function (manual) {
      var self = this;
      if (self._busy || self._done) return;

      var nextUrl = getNextUrl(self.pagWrap);
      if (!nextUrl) {
        self._done = true;
        self.hideLoadMore();
        self.disconnectObserver();
        return;
      }

      self._busy = true;
      setStatusLoading(self.statusEl);
      if (self.loadMoreBtn) self.loadMoreBtn.setAttribute('aria-busy', 'true');

      var absNext = absoluteUrl(nextUrl);
      var sectionUrl = self.sectionId
        ? absNext + (absNext.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(self.sectionId)
        : absNext;

      LOG('fetching', sectionUrl);

      fetch(sectionUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newList = findListInDoc(doc, self.sectionId);
          var newPag = findPaginationInDoc(doc);

          if (!newList || newList.children.length === 0) {
            LOG('section render returned no products, falling back to full page fetch');
            return fetch(absNext, { credentials: 'same-origin' })
              .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
              .then(function (fullHtml) {
                var fullDoc = parser.parseFromString(fullHtml, 'text/html');
                return { newList: findListInDoc(fullDoc, self.sectionId), newPag: findPaginationInDoc(fullDoc) };
              });
          }
          return { newList: newList, newPag: newPag };
        })
        .then(function (parts) {
          if (!parts || !parts.newList) throw new Error('No product list found in fetched HTML');
          var addedCount = parts.newList.children.length;
          LOG('appending ' + addedCount + ' products');

          // Strip reveal-on-scroll BEFORE appending so we never have a hidden flash.
          unhideAppendedCards(parts.newList);

          var frag = document.createDocumentFragment();
          while (parts.newList.firstChild) frag.appendChild(parts.newList.firstChild);
          self.listEl.appendChild(frag);

          // Belt and suspenders: also unhide once attached (in case the theme re-adds attributes on connectedCallback).
          unhideAppendedCards(self.listEl);

          if (parts.newPag) {
            if (!parts.newPag.hasAttribute('data-infinite-pagination')) {
              parts.newPag.setAttribute('data-infinite-pagination', '');
            }
            var fetchedNextUrl = parts.newPag.getAttribute('data-next-url') || '';
            if (!fetchedNextUrl) {
              var fa = parts.newPag.querySelector('a[rel="next"]');
              if (fa) fetchedNextUrl = fa.getAttribute('href');
            }
            self.pagWrap.setAttribute('data-next-url', fetchedNextUrl || '');
            self.pagWrap.innerHTML = parts.newPag.innerHTML;
          } else {
            self.pagWrap.setAttribute('data-next-url', '');
          }

          self._loaded += 1;

          var updatedNext = getNextUrl(self.pagWrap);
          if (self.loadMoreBtn) self.loadMoreBtn.setAttribute('href', updatedNext || '#');

          if (!updatedNext) {
            self._done = true;
            self.hideLoadMore();
            self.disconnectObserver();
            if (self.sentinel) self.sentinel.remove();
          } else if (manual || self._loaded >= AUTO_LOAD_LIMIT) {
            self.showLoadMore();
            self.disconnectObserver();
          }

          clearStatus(self.statusEl);
          if (self.loadMoreBtn) self.loadMoreBtn.removeAttribute('aria-busy');

          self.dispatchEvent(new CustomEvent('infinite-scroll:loaded', {
            bubbles: true,
            detail: { count: addedCount, page: self._loaded }
          }));

          // Final safety pass on the next animation frame, in case the theme's product-card
          // re-applies any reveal state during its connectedCallback.
          requestAnimationFrame(function () { unhideAppendedCards(self.listEl); });
        })
        .catch(function (err) {
          WARN('loadNext failed:', err);
          setStatusError(self.statusEl);
          self.showLoadMore();
          if (self.loadMoreBtn) self.loadMoreBtn.removeAttribute('aria-busy');
        })
        .then(function () { self._busy = false; });
    };

    return InfiniteScrollEl;
  })();

  window.customElements.define('infinite-scroll', InfiniteScrollEl);
  LOG('custom element registered.');
})();
